// FAR-97 (FAR-84 §8.1, §9.3): a Base Plan's stored warnings, as the Base Plan
// pickers show them -- a count, and a short list. Pure, so it is tested
// without a browser. Base Plans built before FAR-97 have no warnings and show
// nothing.

// How many SKUs the list names per warning.
export const MAX_LISTED_SKUS = 10

// The planner-facing name of each kind (internal/plan/warnings.go).
export const WARNING_KIND_LABELS = {
  noRunRate: 'No run rate',
  demandOnly: 'No DOS band',
  extendedDemand: 'Demand extended',
  noItemMaster: 'No item master',
  belowMin: 'Below Min DOS',
  overCapacity: 'Over capacity',
  ruleUnits: 'Not capacity-aware',
  unmetDemand: 'Unmet demand',
  heuristic: 'Heuristic plan',
}

// "1 warning", "3 warnings", or null when there are none.
export function warningsCountLabel(basePlan) {
  const n = (basePlan?.warnings || []).length
  if (n === 0) return null
  return n === 1 ? '1 warning' : `${n} warnings`
}

// The list's rows: kind, message, counts, and the first SKUs.
export function warningItems(basePlan, maxSkus = MAX_LISTED_SKUS) {
  return (basePlan?.warnings || []).map((w) => {
    const skus = w.skus || []
    const months = w.months || []
    return {
      kind: w.kind,
      label: WARNING_KIND_LABELS[w.kind] || w.kind,
      message: w.message || '',
      skuCount: skus.length,
      monthCount: months.length,
      counts: countsLabel(skus.length, months.length),
      skus: skus.slice(0, maxSkus),
      moreSkus: Math.max(0, skus.length - maxSkus),
    }
  })
}

// "12 SKUs · 3 months", "1 SKU", "" when neither.
export function countsLabel(skuCount, monthCount) {
  const parts = []
  if (skuCount > 0) parts.push(skuCount === 1 ? '1 SKU' : `${skuCount} SKUs`)
  if (monthCount > 0) parts.push(monthCount === 1 ? '1 month' : `${monthCount} months`)
  return parts.join(' · ')
}
